import { useState, useEffect, useCallback } from 'react';
import type { AdminUser } from '@yawi/types';
import { useServices } from '@/app/providers';

export function useAdminUsers() {
  const { adminUserRepository } = useServices();
  const [admins, setAdmins] = useState<AdminUser[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchAdmins = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await adminUserRepository.findAll();
      setAdmins(data);
    } catch (err) {
      setAdmins([]);
      setError(err instanceof Error ? err.message : 'No se pudo cargar la lista de administradores');
    } finally {
      setIsLoading(false);
    }
  }, [adminUserRepository]);

  useEffect(() => {
    fetchAdmins();
  }, [fetchAdmins]);

  return {
    admins,
    isLoading,
    error,
    refresh: fetchAdmins,
  };
}
